define 'controller/SimpleDataLayerClickRedirectController', ['jquery'], ($) ->
  class SimpleScrollDataLayerController

    constructor: (@$el) ->
      @$self = @$el
      @_init()

    _init: ->
      root = @
      root.$self.on 'click', (e) -> root._onClick(e)
    _onClick: (event) ->
      event.preventDefault()
      element = event.currentTarget
      productId = element.dataset.externalKey
      template = element.dataset.template
      ref = element.dataset.ref
      position = element.dataset.position
      subtype = element.dataset.subtype
      href = element.dataset.url
      trackingToken = element.dataset.trackingToken
      encodedRef = "&ref="+ref
      data =productId.concat(encodedRef,"&template=",template,"&position=",position,"&subtype=",subtype)
      if (trackingToken)
        trackingData = productId.substring(0,6).concat("&trackingToken=",encodeURIComponent(trackingToken))
        $.ajax
          url: "/api/gk/click/product?pid="+ trackingData
          type: 'POST'
          xhrFields:
            showLoadingIndicator: false
      if(subtype)
        event = $.ajax
          url: "/api/datalayer/event/clickEvent?externalKey="+ data
          type: 'GET'
          xhrFields:
            showLoadingIndicator: false
          success: (content) ->
            if content == undefined
              return
            dataLayer.push(content)
          complete: ->
            window.location = href
      else
        window.location = href



